import React from 'react'
import './Separator.css'

const Separator = () => {
	return (
		<div className='separator'></div>
	);
}

export default Separator